import {filter, fromEvent, Observable} from "rxjs";
import {CriiptoResponsStatus} from "../tjenester/ressurser/generertNg2HttpKlient";
import {logVerdiLevert} from "felles-ng2/støttefunksjoner/observable";

/** Lytter på 'message' eventer på window der event.data.type == criiptoSignert.
 * Se lederplan-tjenester/src/main/resources/no/systemfabrikken/lederplan/tjenester/criipto/criiptoSignertRespons.html
 * for meldingssender-siden. */
export function lyttTilCriiptoSignertHendelser(): Observable<CriiptoEvent<CriiptoSignertMelding>> {
    return fromEvent(window, 'message')
      .pipe(logVerdiLevert('MESSAGE'),filter(melding => erCriiptoSignertMelding(melding)));
}

export function erCriiptoSignertMelding(melding: any): melding is CriiptoEvent<CriiptoSignertMelding> {
    return melding?.data?.type == 'criiptoSignert';
}

/** Lytter på 'message' eventer på window der event.data.type == criiptoAutentisert.
 * Se lederplan-tjenester/src/main/resources/no/systemfabrikken/lederplan/tjenester/openid/criiptoAutentisertRespons.html
 * for meldingssender-siden. */
export function lyttTilCriiptoAutentisertHendelser(): Observable<CriiptoEvent<CriiptoAutentisertMelding>> {
    return fromEvent(window, 'message')
      .pipe(filter(melding => erCriiptoAutentisertMelding(melding)),);
}

export function erCriiptoAutentisertMelding(melding: any): melding is CriiptoEvent<CriiptoAutentisertMelding> {
    return melding?.data?.type == 'criiptoAutentisert';
}

interface CriiptoEvent<CRIIPTO_MELDING extends CriiptoSignertMelding | CriiptoAutentisertMelding> extends Event {
    origin: string;
    data: CRIIPTO_MELDING;
}


/** Data sendt med i melding som sendes fra criipto-iframe til forelder vhja window.parent.postMessage(CriiptoSignertMelding).
 * Se lederplan-tjenester/src/main/resources/no/systemfabrikken/lederplan/tjenester/criipto/criiptoSignertRespons.html */
export interface CriiptoSignertMelding {
    type: 'criiptoSignert';
    href: string;
    status: CriiptoResponsStatus,
    error: string
}

/** data sendt med i melding som sendes fra bankid-iframe til forelder vhja window.parent.postMessage(CriiptoAutentisertMelding).
 * Se lederplan-tjenester/src/main/resources/no/systemfabrikken/lederplan/tjenester/openid/criiptoAutentisertRespons.html */
export interface CriiptoAutentisertMelding {
    type: 'criiptoAutentisert';
    code: string;
    state: string;
    /** ikke-tom streng dersom bruker avbrøt bankid dialogen eller annen feil oppstod */
    error: string;
}
